import { createRouter, createWebHashHistory } from 'vue-router';
import LoginPage from '@/pages/LoginPage.vue';
import DataDisplayPage from '@/pages/DataDisplayPage.vue';
import AdminPage from '@/pages/AdminPage.vue';
import PhoneVerify from '@/pages/PhoneVerify.vue';
import AnchorAdmin from '@/pages/AnchorAdmin.vue';
import DashboardPage from '@/pages/DashboardPage.vue';
import PrayPage from '@/pages/PrayPage.vue';

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: LoginPage },

  {
    path: '/data',
    component: DataDisplayPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/Admin',
    component: AdminPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/PrayPage',
    component: PrayPage,
    meta: { requiresAuth: true }
  },

  {
    path: '/Dashboard',
    component: DashboardPage,
    children: [
      {
        path: '/Admin',
        name: 'Recharge',
        component: AdminPage
      },
      {
        path: '/AdminAnchor',
        name: 'Anchor',
        component: AnchorAdmin
      },
      {
        path: '/PrayPage',
        name: 'Pray',
        component: PrayPage
      }
    ]
  },

  {
    path: '/AdminAnchor',
    component: AnchorAdmin,
    meta: { requiresAuth: true }
  },

  {
    path: '/phone-verify',
    name: 'PhoneVerify',
    component: PhoneVerify
  },

  { path: '/:pathMatch(.*)*', redirect: '/login' }
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
});

// 登录守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (to.meta.requiresAuth && !token) {
    next('/login');
  } else {
    next();
  }
});

export default router;